module.exports = __webpack_public_path__ + "img/slide-47.44207634.png";